/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Combobox, useMantineTheme, rem } from '@mantine/core';

import type { PropsWithChildren } from '@fai/util/types';

import { MenuOptions } from './team-menu';
import { CurrentTeamProfileSection } from './team-profile';
import { AllTeamsOption, SwitchableTeamsSection } from './team-switchable-list';

function DropDown({ children }: PropsWithChildren) {
  const theme = useMantineTheme();

  return (
    <Combobox.Dropdown
      miw={rem(240)}
      p={0}
      style={{
        borderRadius: theme.pf.layout['3xs'],
      }}
    >
      <Combobox.Options>{children}</Combobox.Options>
    </Combobox.Dropdown>
  );
}

DropDown.displayName = 'TeamSelectDropDown';

DropDown.CurrentTeamProfileSection = CurrentTeamProfileSection;
DropDown.MenuOptions = MenuOptions;
DropDown.SwitchableTeamsSection = SwitchableTeamsSection;
DropDown.AllTeamsOption = AllTeamsOption;

export default DropDown;
